module.exports = __webpack_public_path__ + "static/media/teaser-klimazukunft.240c3576.jpg";